import {
	Component,
	Input,
	OnChanges,
	OnInit,
	SimpleChanges,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { ProfileService } from 'src/app/pages/app/profile/services/profile.service';
import { RudderStack } from 'src/app/services';

@Component({
	selector: 'app-progress-bar',
	templateUrl: './progress-bar.component.html',
	styleUrls: ['./progress-bar.component.scss'],
})
export class ProgressBarComponent implements OnInit, OnChanges {
	expand = false;
	bgGradient: string;
	@Input() barAnalytics: any;
	@Input() overDueAssignments: any;
	@Input() text: any;
	@Input() percentage: string;
	constructor(private router: Router,
		private rudderStack: RudderStack,
		private activatedRoute: ActivatedRoute,
		private profileService: ProfileService,
	) { }
	cohortId;
	profileId;
	router$ = this.activatedRoute.params
		.pipe(
			map(p => Number(p.cohortId)),
			filter(p => !!p),
		).subscribe(cohortId => {
			this.cohortId = cohortId
		})

	ngOnInit() {
		this.profileService.loadProfileData().subscribe(data => {
			this.profileId = data?.data?.id;
		})
		// this.bgGradient = `linear-gradient(to right, #38ae8b 0%, #38ae8b ${this.percentage}, #f0fdfa ${this.percentage}, #f0fdfa 100%)`;
	}
	ngOnChanges(changes: SimpleChanges) {
		this.bgGradient = `linear-gradient(to right, #38ae8b 0%, #38ae8b ${this.percentage}, #f0fdfa ${this.percentage}, #f0fdfa 100%)`;
	}
	goToAssignment(id, cohortId, data) {
		this.rudderStack.log({
			type: 'attention_item_click',
			profileId: this.profileId ,
			cohortId: this.cohortId,
			eventType: data.type,
			name: data.name,
		});
		this.router.navigate([
			`/app/learning/${cohortId}/assignments/assignment-id/${id}`,
		]);
		//
	}
	expandProgressBar() {
		this.expand = !this.expand;
		if(this.expand){
			this.rudderStack.log({
				type: 'progresscard_click',
				profileId: this.profileId ,
				cohortId: this.cohortId,
			});
		}
	}
}
